import { ButtonBase, ClickAwayListener, Fade, Paper, Popper } from "@mui/material";
import { COLOR_GREY_BORDER, COLOR_WHITE_LIGHTER } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { MenuDown } from "mdi-material-ui";
import { AccountArrowRightOutline } from "mdi-material-ui";
import GamePlayerSelector from "pages/games/GamePlayerSelector";
import React, { useState } from "react";

export function PlayerListDropdown({
  game,
  selectedPlayerId,
  onSelect,
  buttonLabel = "Select player",
  disabled = false,
  isLoading = false,
}) {
  const [open, openSet] = useState(false);
  const [anchorEl, anchorElSet] = useState(null);
  const players = game?.gamePlayers ?? [];

  const totalPlayers = players.length;
  const buttonDisabled = disabled || (!isLoading && totalPlayers === 0);

  const handleToggle = (event) => {
    anchorElSet(event.currentTarget);
    openSet((prev) => !prev);
  };

  const handleClose = () => openSet(false);

  const handlePlayerSelect = (playerId) => {
    const selected = players.find((player) => player.id === playerId);
    if (selected) {
      onSelect?.(selected);
      openSet(false);
    }
  };

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <ButtonBase
        onClick={handleToggle}
        disabled={buttonDisabled}
        style={{
          border: `1px solid ${COLOR_GREY_BORDER}`,
          borderRadius: 12,
          padding: "6px 16px",
          backgroundColor: COLOR_WHITE_LIGHTER,
          textTransform: "none",
          fontSize: "0.75em",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <AccountArrowRightOutline style={{ fontSize: "1.2em" }} />
        <span
          style={{
            whiteSpace: "nowrap",
            maxWidth: 250,
            overflow: "hidden",
            fontFamily: FONT_FAMILY_GRAPHIK,
            fontWeight: 500,
            textOverflow: "ellipsis",
          }}
        >
          {buttonLabel}
        </span>
        <MenuDown
          sx={{
            fontSize: "1.2em",
            transition: "transform 0.2s ease",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </ButtonBase>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        transition
        style={{ zIndex: 2 }}
        modifiers={[{ name: "flip", enabled: false }]}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={150}>
            <div>
              <ClickAwayListener onClickAway={handleClose}>
                <Paper
                  style={{
                    padding: 2,
                  }}
                >
                  <GamePlayerSelector
                    game={game}
                    gamePlayerId={selectedPlayerId}
                    gamePlayerIdSet={handlePlayerSelect}
                  />
                </Paper>
              </ClickAwayListener>
            </div>
          </Fade>
        )}
      </Popper>
    </div>
  );
}
